import { ArrowUpRight, BellRing, X } from 'lucide-react'

import { Badge, Button } from '@/components/ui'

type RealtimeApplicationToastProps = {
  applicationNumber: number
  schemaName?: string
  squareNames: string[]
  stageName?: string
  onClose: () => void
  onOpen: () => void
}

function MetaTile({ label, value }: { label: string; value?: string }) {
  if (!value) {
    return null
  }

  return (
    <div className="rounded-2xl border border-ink-100/80 bg-ink-50/80 px-3 py-2">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-ink-400">
        {label}
      </p>
      <p className="mt-1 text-sm font-semibold text-ink-900">{value}</p>
    </div>
  )
}

export function RealtimeApplicationToast({
  applicationNumber,
  schemaName,
  squareNames,
  stageName,
  onClose,
  onOpen,
}: RealtimeApplicationToastProps) {
  const squareLabel =
    squareNames.length > 0 ? squareNames.join(', ') : 'доступном квадрате'

  return (
    <div className="pointer-events-auto w-[min(24rem,calc(100vw-1.5rem))] overflow-hidden rounded-[28px] border border-white/80 bg-white/95 shadow-[0_24px_60px_rgba(15,23,42,0.22)] backdrop-blur">
      <div className="h-1.5 bg-[linear-gradient(90deg,#e96f2b_0%,#10243f_50%,#17a36b_100%)]" />
      <div className="space-y-4 p-5">
        <div className="flex items-start gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-accent-50 text-accent-700 shadow-inner">
            <BellRing className="h-5 w-5" />
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <Badge tone="accent">Новая заявка</Badge>
              <span className="text-xs font-medium text-ink-400">Только что</span>
            </div>
            <p className="mt-2 text-lg font-bold tracking-tight text-ink-950">
              Заявка #{applicationNumber}
            </p>
            <p className="mt-1 text-sm leading-6 text-ink-500">
              Появилась в {squareLabel}.
            </p>
          </div>

          <button
            aria-label="Закрыть уведомление"
            className="rounded-2xl p-2 text-ink-400 transition hover:bg-ink-100 hover:text-ink-700"
            onClick={onClose}
            type="button"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="grid gap-2 sm:grid-cols-2">
          <MetaTile label="Схема" value={schemaName} />
          <MetaTile label="Этап" value={stageName} />
        </div>

        <div className="flex gap-2">
          <Button className="flex-1" onClick={onOpen}>
            <ArrowUpRight className="mr-2 h-4 w-4" />
            Открыть
          </Button>
          <Button onClick={onClose} tone="ghost">
            Позже
          </Button>
        </div>
      </div>
    </div>
  )
}
